let language = {
    ORDER_GENERATE_PENDING_TITLE: "Order {{combineOrderId}} is being generated, please hold on. Once generated, the system will automatically redirect to the payment page",
    ORDER_GENERATE_PENDING_DESCRIPTION_FRONT: 'If you have set up automatic payment, you may safely close this window and do not need to wait here. If you accidentally close the page, you can check this order in the "',
    ORDER_GENERATE_PENDING_DESCRIPTION_LINK: 'Partner Orders',
    ORDER_GENERATE_PENDING_DESCRIPTION_END: '"section'
};

export { language }